import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import type { ReactionProp } from "@src/app/types/Reactions";
import { reactionCount } from "@src/app/utils/reactionCount";
import cx from "classnames";

import styles from "./ReactionWidget.module.css";

export type ReactionEmojiProps = {
  reaction: ReactionProp;
  selected: boolean;
  disabled: boolean;
  onToggle: (id: string) => void;
};

export default function ReactionEmoji({
  reaction,
  selected,
  disabled,
  onToggle,
}: ReactionEmojiProps) {
  return (
    <button
      type="button"
      className={cx(
        styles.reactionEmoji,
        selected && styles.reactionEmojiSelected,
      )}
      aria-label={`React ${reaction.text}`}
      aria-pressed={selected}
      disabled={disabled}
      onClick={() => {
        onToggle(reaction.id);
      }}
    >
      <DotLottieReact
        src={`/reactions/${reaction.id}.json`}
        loop
        autoplay
        className={styles.reactionLottie}
      />
      <div className={styles.reactionCount}>
        {reactionCount(reaction.count)}
      </div>
    </button>
  );
}
